import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, isRef as _isRef } from "vue"
import _imports_0 from '@/assets/svg/cancel.svg'
import _imports_1 from '@/assets/svg/checkmark.svg'


const _hoisted_1 = { class: "modal-title" }
const _hoisted_2 = { class: "ms-header-items" }
const _hoisted_3 = { class: "ms-header-items" }
const _hoisted_4 = { class: "ms-header-items" }
const _hoisted_5 = { class: "main-area" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "NKT-P1"
}
const _hoisted_8 = {
  key: 1,
  class: "NKT-P1 mb-2"
}
const _hoisted_9 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_10 = { style: {"margin-right":"32px"} }
const _hoisted_11 = { class: "main-chart" }
const _hoisted_12 = {
  key: 4,
  class: "ms-related-documents-title"
}
const _hoisted_13 = { key: 5 }
const _hoisted_14 = { class: "ms-actions" }
const _hoisted_15 = {
  key: 6,
  class: "NKT-P2"
}
const _hoisted_16 = {
  key: 7,
  class: "ms-logs"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]

import arrow from '@/assets/svg/arrow.svg'
import InlineConfirmationDialog from '@/components/dialogs/InlineConfirmationDialog.vue'
import FilesTable from '@/components/documentation/FilesTable.vue'
import AisDataProperties from '@/components/properties/AisDataProperties.vue'
import AlarmLogs from '@/components/properties/AlarmLogs.vue'
import {
  Alarm,
  AlarmActivationType,
  AlarmClient,
  AlarmSourceType,
  DocumentationClient,
  File,
  FilesRequest,
  RelationType,
  UpdateActivationRequest
} from '@/server/MakeSenseApp-backend'
import { useProjectStore } from '@/stores/ProjectStore'
import { useUserStore } from '@/stores/UserStore'
import { ButtonStyles, ModalSize } from '@/utilities/enums'
import { requiredInject } from '@/utilities/requiredInject'
import moment from 'moment'
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import AlarmSources from '../cells/AlarmSourcesCell.vue'
import DateTime from '../cells/DateTimeCell.vue'
import KpCell from '../cells/KpCell.vue'
import AlarmDASChart from '../charts/alarmCharts/AlarmDASChart.vue'
import AlarmDoBChart from '../charts/alarmCharts/AlarmDoBChart.vue'
import AlarmDTSChart from '../charts/alarmCharts/AlarmDTSChart.vue'
import ModalButton from '../general/buttons/ModalButton.vue'
import MsButton from '../general/buttons/MsButton.vue'
import MsModal from '../general/modal/MsModal.vue'
import SparePartsInventory from '../spareparts/SparePartsInventory.vue'
const modalId = 'alarmModal'


export default /*@__PURE__*/_defineComponent({
  __name: 'AlarmModal',
  props: {
  alarms: Array<Alarm>,
  selectedId: String,
  pushRoute: Boolean
},
  setup(__props) {

var props = __props

var router = useRouter()

const activeAlarm = ref<Alarm | undefined>()

var open = ref(false)
var showDeactivateDialog = ref(false)
var isLoadingSubmit = ref(false)
var sendRequestToNKT = ref(false)
var files = ref<Array<File>>([])

let userStore = useUserStore()
let projectStore = useProjectStore()

var alarmClient = requiredInject<AlarmClient>('AlarmClient')

const selectedAlarm = computed(() => {
  if (activeAlarm.value !== undefined) {
    return activeAlarm.value
  }
  return props.alarms?.find((alarm) => alarm.id === props.selectedId)
})

function sendEvaluation() {
  alarmClient.requestEvaluation(projectStore.projectId)
  sendRequestToNKT.value = true
}

function hasNextAlarm() {
  const index = findIndex()
  return index !== undefined && index < props.alarms!.length - 1
}

function nextAlarm() {
  const index = findIndex()
  if (index !== undefined && index < props.alarms!.length - 1) {
    activeAlarm.value = props.alarms?.[index + 1]
    updateVisitedAlarm()
    resetState()
    refresh()
  }
}

function hasPrevAlarm() {
  const index = findIndex()
  return index !== undefined && index > 0
}

function prevAlarm() {
  const index = findIndex()
  if (index !== undefined && index > 0) {
    activeAlarm.value = props.alarms?.[index - 1]
    updateVisitedAlarm()
    resetState()
    refresh()
  }
}

function refresh() {
  open.value = false

  setTimeout(() => {
    open.value = true
  }, 1)
}

function findIndex(): number | undefined {
  return props.alarms?.findIndex((alarm) => alarm.id === activeAlarm.value?.id)
}

function toSparePartDate(date: Date | undefined) {
  return moment(date).format('YYYY-MM-DD')
}

function confirmDeactivation(comment: string) {
  let alarm = selectedAlarm.value
  if (alarm != null && alarm.projectId != null && alarm.id != null) {
    isLoadingSubmit.value = true

    var request = new UpdateActivationRequest({
      action: alarm.active ? AlarmActivationType.Deactivate : AlarmActivationType.Activate,
      comment: comment
    })

    alarmClient.updateActivation(alarm.projectId, alarm.id, request).then((updatedData) => {
      isLoadingSubmit.value = false
      alarm.active = updatedData.active
      alarm.logs = updatedData.logs
    })
  }

  showDeactivateDialog.value = false
}

function cancelDeactivation() {
  showDeactivateDialog.value = false
}

onMounted(() => {
  const modalElement = document.getElementById(modalId)
  var documentClient = requiredInject<DocumentationClient>('DocumentationClient')

  if (modalElement) {
    modalElement.addEventListener('show.bs.modal', handleShow)
    modalElement.addEventListener('shown.bs.modal', handleShown)
    modalElement.addEventListener('hide.bs.modal', handleHide)
  }

  watch(
    () => [projectStore.selectedProject],
    () => {
      documentClient
        .getFiles(
          new FilesRequest({
            relatedProjects: [projectStore.projectId],
            relationType: RelationType.AISMonitoringReport
          })
        )
        .then((data) => {
          files.value = data
        })
    }
  ),
    { immediate: true }
})

onUnmounted(() => {
  const modalElement = document.getElementById(modalId)
  if (modalElement) {
    modalElement.removeEventListener('show.bs.modal', handleShow)
    modalElement.removeEventListener('shown.bs.modal', handleShown)
    modalElement.removeEventListener('hide.bs.modal', handleHide)
  }
})

const handleShow = () => {
  open.value = true
  isLoadingSubmit.value = false
}

const handleHide = () => {
  if (props.pushRoute) {
    router.replace({ name: 'alarms' })
  }

  open.value = false
  activeAlarm.value = undefined
  resetState()
}

const handleShown = function () {
  updateVisitedAlarm()
  activeAlarm.value = props.alarms?.find((alarm) => alarm.id === props.selectedId)
}

function updateVisitedAlarm() {
  var alarm = selectedAlarm.value
  if (alarm && alarm.projectId && alarm.id) {
    alarmClient.visitedAlarm(alarm.projectId, alarm.id)
    alarm.visited = true

    if (props.pushRoute) {
      router.replace({ name: 'alarms', params: { id: alarm.id } })
    }
  }
}

function resetState() {
  showDeactivateDialog.value = false
  isLoadingSubmit.value = false
  sendRequestToNKT.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MsModal, {
    "modal-id": modalId,
    "modal-width": _unref(ModalSize).xl
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(AlarmSources, {
            alarmSources: selectedAlarm.value?.alarmSources
          }, null, 8, ["alarmSources"])
        ]),
        _createElementVNode("span", _hoisted_3, [
          _createVNode(DateTime, {
            timestamp: selectedAlarm.value?.timestamp
          }, null, 8, ["timestamp"])
        ]),
        _createElementVNode("span", _hoisted_4, [
          _createVNode(KpCell, {
            kp: selectedAlarm.value?.kp,
            active: selectedAlarm.value?.active
          }, null, 8, ["kp", "active"])
        ])
      ]),
      _createVNode(MsButton, {
        "data-bs-dismiss": "modal",
        "aria-label": "Close",
        id: "close-modal",
        "button-custom-style": "btn-close"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createElementVNode("img", {
            src: _imports_0,
            class: "icon"
          }, null, -1)
        ])),
        _: 1
      })
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        (_unref(open))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[8] || (_cache[8] = _createElementVNode("h2", null, "Alarm Details", -1)),
              (selectedAlarm.value?.alarmSource?.type === _unref(AlarmSourceType).SpareParts)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Spare part is expiring on " + _toDisplayString(toSparePartDate(selectedAlarm.value.sparePartData?.expirationDate)) + ", reach out to NKT to order as soon as possible to reduce risk of downtime. ", 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createTextVNode(_toDisplayString(selectedAlarm.value?.description) + " ", 1),
                    (selectedAlarm.value?.hasRange)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("span", _hoisted_10, [
                            _cache[2] || (_cache[2] = _createTextVNode("Alarm start: ")),
                            _createVNode(DateTime, {
                              timestamp: selectedAlarm.value?.startTimestamp
                            }, null, 8, ["timestamp"])
                          ]),
                          _createElementVNode("span", null, [
                            _cache[3] || (_cache[3] = _createTextVNode("Alarm end: ")),
                            _createVNode(DateTime, {
                              timestamp: selectedAlarm.value?.timestamp
                            }, null, 8, ["timestamp"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])),
              (
              _unref(open) &&
              selectedAlarm.value?.alarmSource?.type == _unref(AlarmSourceType).AIS &&
              selectedAlarm.value?.aisData
            )
                ? (_openBlock(), _createBlock(AisDataProperties, {
                    key: 2,
                    kp: selectedAlarm.value?.kp,
                    data: selectedAlarm.value?.aisData,
                    coordinate: selectedAlarm.value?.coordinate
                  }, null, 8, ["kp", "data", "coordinate"]))
                : _createCommentVNode("", true),
              (_unref(open) && selectedAlarm.value?.sparePartData?.sparePartGroups)
                ? (_openBlock(), _createBlock(SparePartsInventory, {
                    key: 3,
                    inventory: selectedAlarm.value?.sparePartData.sparePartGroups
                  }, null, 8, ["inventory"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                (_unref(open) && selectedAlarm.value?.alarmSource?.type == _unref(AlarmSourceType).DTS)
                  ? (_openBlock(), _createBlock(AlarmDTSChart, {
                      key: 0,
                      alarm: selectedAlarm.value
                    }, null, 8, ["alarm"]))
                  : _createCommentVNode("", true),
                (_unref(open) && selectedAlarm.value?.alarmSource?.type == _unref(AlarmSourceType).DAS)
                  ? (_openBlock(), _createBlock(AlarmDASChart, {
                      key: 1,
                      alarm: selectedAlarm.value
                    }, null, 8, ["alarm"]))
                  : _createCommentVNode("", true)
              ]),
              ((selectedAlarm.value?.alarmSources?.length ?? 0) > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Related Data", -1)),
                    (
                _unref(open) &&
                selectedAlarm.value?.alarmSources?.some((x) => x.type == _unref(AlarmSourceType).DAS) &&
                selectedAlarm.value?.alarmSource?.type !== _unref(AlarmSourceType).DAS
              )
                      ? (_openBlock(), _createBlock(AlarmDASChart, {
                          key: 0,
                          class: "mb-6",
                          alarm: selectedAlarm.value
                        }, null, 8, ["alarm"]))
                      : _createCommentVNode("", true),
                    (
                _unref(open) &&
                selectedAlarm.value?.alarmSources?.some((x) => x.type == _unref(AlarmSourceType).AIS) &&
                selectedAlarm.value?.alarmSource?.type !== _unref(AlarmSourceType).AIS &&
                selectedAlarm.value?.aisData
              )
                      ? (_openBlock(), _createBlock(AisDataProperties, {
                          key: 1,
                          class: "mb-6",
                          kp: selectedAlarm.value?.kp,
                          data: selectedAlarm.value?.aisData
                        }, null, 8, ["kp", "data"]))
                      : _createCommentVNode("", true),
                    (
                _unref(open) &&
                selectedAlarm.value?.alarmSources?.some((x) => x.type == _unref(AlarmSourceType).DoB) &&
                selectedAlarm.value?.alarmSource?.type !== _unref(AlarmSourceType).DoB
              )
                      ? (_openBlock(), _createBlock(AlarmDoBChart, {
                          key: 2,
                          class: "mb-6",
                          alarm: selectedAlarm.value
                        }, null, 8, ["alarm"]))
                      : _createCommentVNode("", true),
                    (
                _unref(open) &&
                selectedAlarm.value?.alarmSources?.some((x) => x.type == _unref(AlarmSourceType).DTS) &&
                selectedAlarm.value?.alarmSource?.type !== _unref(AlarmSourceType).DTS
              )
                      ? (_openBlock(), _createBlock(AlarmDTSChart, {
                          key: 3,
                          alarm: selectedAlarm.value
                        }, null, 8, ["alarm"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (selectedAlarm.value?.alarmSource?.type === _unref(AlarmSourceType).AIS)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "ms-related-documents-title" }, [
                      _createElementVNode("h5", null, "Related Documents")
                    ], -1)),
                    _createVNode(FilesTable, { files: _unref(files) }, null, 8, ["files"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                (_unref(userStore).isOwnerOrHigher)
                  ? (_openBlock(), _createBlock(MsButton, {
                      key: 0,
                      disabled: _unref(sendRequestToNKT),
                      buttonType: _unref(ButtonStyles).Tertiary,
                      onClick: sendEvaluation
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode("Request NKT Evaluation")
                      ])),
                      _: 1
                    }, 8, ["disabled", "buttonType"]))
                  : _createCommentVNode("", true),
                (_unref(userStore).isOwnerOrHigher)
                  ? (_openBlock(), _createBlock(ModalButton, {
                      key: 1,
                      "button-type": selectedAlarm.value?.active ? 'Highlighted' : 'Secondary',
                      text: selectedAlarm.value?.active ? 'Deactivate Alarm' : 'Reactivate Alarm',
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(showDeactivateDialog) //@ts-ignore
 ? showDeactivateDialog.value = true : showDeactivateDialog = true))
                    }, null, 8, ["button-type", "text"]))
                  : _createCommentVNode("", true),
                _createVNode(InlineConfirmationDialog, {
                  show: _unref(showDeactivateDialog),
                  title: `Are you sure you want to ${
                selectedAlarm.value?.active ? 'deactivate' : 'reactivate'
              }?`,
                  onConfirm: confirmDeactivation,
                  onCancel: cancelDeactivation
                }, null, 8, ["show", "title"])
              ]),
              (_unref(sendRequestToNKT))
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[7] || (_cache[7] = [
                    _createElementVNode("img", {
                      class: "checkmark",
                      src: _imports_1
                    }, null, -1),
                    _createTextVNode(" We have registered your request, and you will hear from us shortly. ")
                  ])))
                : _createCommentVNode("", true),
              (selectedAlarm.value && (selectedAlarm.value?.logs?.length ?? 0) > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(AlarmLogs, {
                      alarm: selectedAlarm.value!
                    }, null, 8, ["alarm"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      (hasPrevAlarm())
        ? (_openBlock(), _createBlock(MsButton, {
            key: 0,
            onClick: prevAlarm,
            "button-custom-style": "ms-button-link-blue",
            "button-font": "NKT-P2"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _unref(arrow),
                class: "arrow-left icon mb-1"
              }, null, 8, _hoisted_17),
              _cache[9] || (_cache[9] = _createTextVNode(" Previous"))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (hasNextAlarm())
        ? (_openBlock(), _createBlock(MsButton, {
            key: 1,
            onClick: nextAlarm,
            "button-custom-style": "ms-button-link-blue",
            "button-font": "NKT-P2"
          }, {
            default: _withCtx(() => [
              _cache[10] || (_cache[10] = _createTextVNode(" Next ")),
              _createElementVNode("img", {
                src: _unref(arrow),
                class: "arrow-right icon mb-1"
              }, null, 8, _hoisted_18)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modal-width"]))
}
}

})